<template>
    <FullFillBox
        v-if="stockTakeMain"
        :pageID="5"
        :otherPer="[6,7]"
        @permissionData="(data) => {
            this.permissionDetails = data
            if(data.add === 1){
                this.showAddButton = true
            }
            if(data.edit === 1){
                this.showEditButton = true
            }
            if(data.delete === 1){
                this.showDeleteButton = true
            }
        }"
        @otherPermission="(data) => {
            if(data[0].status === 80){
                this.exportButtonCanSpawn = true
            }
            if(data[1].status === 80){
                this.adjustButtonCanSpawn = true
            }
        }"
    >
        <h4>{{ stockTakeMain.name }}<span style="font-size: 12px">&nbsp;&nbsp;&nbsp;(&nbsp;{{ stockTakeMain.createTime }}&nbsp;)</span></h4>
        <hr>
        <ProductFilterMultiSelect
            :mainData="mainData"
            ref="filterBar"
            v-if="mainData"
            @getFilteredData="(data) => {
                    this.tabulator.setData(data)
                    this.tabulator.redraw(true)
                }"
        />
        <hr>
        <div class="row g-1">
            <div class="col-lg-3">
                <button class="btn btn-primary" @click="reloadTable" style="width: 200px;">
                    {{ $t('common_reload') }}
                </button>
            </div>
            <div class="col-lg-3">
                <button class="btn btn-primary"
                        v-if="showAddButton"
                        @click="addNewRecord" style="width: 200px;">
                    {{ $t('common_add') }}
                </button>
            </div>
            <div class="col-lg-3">
                <select class="form-select" v-model="filterBy" @change="tableFilterBy">
                    <option value="all">{{ $t('stock_take_detail_filter_all') }}</option>
                    <option value="less">{{ $t('stock_take_detail_filter_less') }}</option>
                    <option value="more">{{ $t('stock_take_detail_filter_more') }}</option>
                    <option value="ok">{{ $t('stock_take_detail_filter_ok') }}</option>
                </select>
            </div>
            <div class="col-lg-3">
                <select class="form-select" v-model="groupBy" @change="tableGroupBy">
                    <option value="no">{{ $t('inventory_table_gp_no_gp') }}</option>
                    <option value="loc">{{ $t('inventory_table_gp_loc') }}</option>
                    <option value="outCode">{{ $t('inventory_table_gp_outCode') }}</option>
                    <option value="cat">{{ $t('product_category') }}</option>
                    <option value="brand">{{ $t('product_brand') }}</option>
                </select>
            </div>
        </div>
        <hr>
        <div ref="tabulatorTableUse"></div>
        <hr>
        <div class="row p-2">
            <div class="col-md-6">
                <div class="row" v-if="exportButtonCanSpawn">
                    <button class="btn btn-primary" style="width: 200px;" @click="toggleExportExcelPopUp(1)">
                        {{ $t('stock_take_detail_export_full') }}
                    </button>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-3">
                        <p>{{ $t('common_row_selected') }} {{ selectedRowsNum }}</p>
                    </div>
                    <div class="col-md-3">
                        <button class="btn btn-primary" style="width: 200px;" @click="toggleSelectAll">
                        {{ button_name }}
                        </button>
                    </div>
                    <div class="col-md-6">
                        <button class="btn btn-primary" style="width: 200px;"
                                v-if="adjustButtonCanSpawn"
                                @click="adjustNow">
                            {{ $t('stock_take_detail_select_fix') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </FullFillBox>

    <!--   PopupMenu Show Temp List  -->
    <vue-final-modal v-model="showExportExcelPopUp" classes="modal-container" content-class="modal-content"
                     style="margin-top: 20vh;margin-right: 5%;margin-left: 5%;height: 10px">
        <button class="modal__close" @click="toggleExportExcelPopUp(0)">
            <i class="bi bi-x-lg"></i>
        </button>
        <span class="modal__title"></span>
        <div class="modal__content" style="background-color: white;border: black solid 3px;height: auto;width: auto">
            <h4>{{ $t('inventory_table_export_excel') }}</h4>
            <div class="row">
                <div class="col-md-6">
                    <button class="btn btn-primary" style="width: 200px;" @click="getExportExcel('all')">
                        {{ $t('stock_take_detail_export_full') }} {{ $t('stock_take_detail_filter_all') }}
                    </button><br>

                    <button class="btn btn-primary" style="width: 200px;margin-top: 10px" @click="getExportExcel('less')">
                        {{ $t('stock_take_detail_export_full') }} {{ $t('stock_take_detail_filter_less') }}
                    </button><br>

                    <button class="btn btn-primary" style="width: 200px;margin-top: 10px" @click="getExportExcel('more')">
                        {{ $t('stock_take_detail_export_full') }} {{ $t('stock_take_detail_filter_more') }}
                    </button><br>

                    <button class="btn btn-primary" style="width: 200px;margin-top: 10px" @click="getExportExcel('ok')">
                        {{ $t('stock_take_detail_export_full') }} {{ $t('stock_take_detail_filter_ok') }}
                    </button>
                </div>
                <div class="col-md-6">
                    <button class="btn btn-primary" style="width: 200px;" @click="getExportExcel('group')">
                        {{ $t('stock_take_detail_export_group') }}
                    </button>
                </div>
            </div>
        </div>
    </vue-final-modal>

    <!--   PopupMenu Show Temp List  -->
    <vue-final-modal v-model="showEditPopUp" classes="modal-container" content-class="modal-content"
                     style="margin-top: 20vh;margin-right: 5%;margin-left: 5%;height: 10px">
        <button class="modal__close" @click="toggleEditPopUp(0)">
            <i class="bi bi-x-lg"></i>
        </button>
        <span class="modal__title"></span>
        <div class="modal__content" style="background-color: white;border: black solid 3px;height: auto;width: auto">
            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-lg-4 col-form-label">
                            Scanned Qty
                        </div>
                        <div class="col-lg-8">
                            <input class="form-control" type="number" v-model="showEditPopUpScanNum">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-form-label">
                            Remarks
                        </div>
                        <div class="col-lg-8">
                            <input class="form-control" type="text" placeholder="remarks..." v-model="showEditPopUpRemarks">
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-lg-4 col-form-label">
                            Location
                        </div>
                        <div class="col-lg-8">
                            <Multiselect
                                v-model="getLocation"
                                :options="locationList"
                                mode="single"
                                :can-clear=false
                                :searchable="true"
                                :placeholder="this.$t('inventory_search_location') + ' (' + this.locationList.length + ')'"
                            />
                        </div>
                    </div>
                </div>
                <button class="btn btn-primary" style="width: 300px;margin: 5px auto 5px auto"
                        @click="updateStockTakeDetailDetail"
                >{{ $t('common_update') }}</button>
            </div>
        </div>
    </vue-final-modal>

</template>

<script>
import {TabulatorFull as Tabulator} from "tabulator-tables";
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import Multiselect from "@vueform/multiselect";
import ProductFilterMultiSelect from "@/components/ProductFilterMultiSelect.vue";

export default {
    name: "StockTakeDetailsListView",
    components: {
        ProductFilterMultiSelect,
        FullFillBox,
        Multiselect,
    },
    data(){
        return {
            permissionDetails: {},
            showAddButton: false,
            showEditButton: false,
            showDeleteButton: false,
            exportButtonCanSpawn: false,
            adjustButtonCanSpawn: false,
            getCategory: [],
            categoryList: [],
            getBrand: [],
            brandList: [],

            mainData: [],
            stockTakeMain: [],

            groupBy: 'no',
            filterBy: 'all',

            tabulatorTablesList: [],

            showExportExcelPopUp: false,
            showEditPopUp: false,
            locationList: [],
            getLocation: '',
            showEditPopUpRemarks: '',
            showEditPopUpScanNum: '',
            showEditPopUpThisID: '',

            button_name: '',
            selectAllFlag: true,
            selectedRowsNum: 0,

            autoLoader: null,
            scrollPosition: 0,
        }
    },
    watch: {
        '$route.params': {
            async handler(newStockTakeDetailID) {
                await this.getBackendData(newStockTakeDetailID.id)
            },
            immediate: true,
        }
    },
    methods: {
        async updateStockTakeDetailDetail(){
            if(this.showEditPopUpScanNum <= 0){
                this.$swal.fire({
                    text: this.$t('stock_take_detail_new_qty_error'),
                    icon: 'error'
                })
            }else{
                await this.$mainApi.put('api/stock-take/stock-take-detail-details/', {
                    "id": this.showEditPopUpThisID,
                    "qty": this.showEditPopUpScanNum,
                    "remarks": this.showEditPopUpRemarks,
                    "locID": this.getLocation,
                })
                    .then(response => {
                        console.log(response.data)
                        if(response.data.status === 80){
                            this.toggleEditPopUp(0)
                            this.reloadTable()
                        }else{
                            this.$swal.fire({
                                title: response.data.errors,
                                text: JSON.stringify(response.data.details),
                                icon: 'warning'
                            })
                        }
                    })
            }
        },
        async toggleExportExcelPopUp(flag){
            if(flag === 0){
                this.showExportExcelPopUp = false
                this.$store.commit('setIsBlackLayout', false)
            }else{
                this.showExportExcelPopUp = true
                this.$store.commit('setIsBlackLayout', true)
            }
        },
        async toggleEditPopUp(flag, data, getLocID){
            if(flag === 0){
                this.showEditPopUp = false
                this.$store.commit('setIsBlackLayout', false)
            }else{
                await this.getBackendLocation()
                this.getLocation = getLocID
                this.showEditPopUpThisID = data.id
                this.showEditPopUpScanNum = data.scanQty
                this.showEditPopUpRemarks = data.remarks
                this.showEditPopUp = true
                this.$store.commit('setIsBlackLayout', true)
            }
        },
        async getBackendLocation(){
            await this.$mainApi.get('api/other-details/location/')
                .then(response => {
                    if(response.data.status === 80){
                        this.locationList = []
                        for(let i=0;i<response.data.details.length;i++){
                            this.locationList.push({
                                "label": response.data.details[i]['label'],
                                "value": response.data.details[i]['id'],
                            })
                        }
                    }
                })
        },
        async getExportExcel(flag){
            await this.$mainApi.get(`api/stock-take/export-excel?mode=${flag}&id=${this.stockTakeMain.id}`)
                .then(response => {
                    if (response.data.status === 80) {
                        location.href = (this.$store.state.serverIp + response.data.details)
                    } else {
                        this.$swal.fire({
                            title: response.data.errors,
                            text: response.data.details,
                            icon: 'warning'
                        })
                    }
                })
        },
        async adjustNow(){
            if (this.selectedRowsNum <= 0){
                this.$swal.fire({
                    title: this.$t('stock_take_detail_fix_data_required'),
                    icon: 'warning'
                })
            }else{
                this.$swal.fire({
                    title: this.$t('stock_take_detail_fix_confirm'),
                    html: this.$t('stock_take_detail_fix_confirm2'),
                    icon: 'info',
                }).then(async result => {
                    if(await result.isConfirmed){
                        let a = Math.floor(Math.random() * 10) + 1
                        let b = Math.floor(Math.random() * 10) + 1
                        this.$swal.fire({
                            icon: 'info',
                            title: this.$t('stock_take_detail_fix_confirm3'),
                            html: `<h4>${a} + ${b} = ?</h4>`,
                            input: "number",
                            inputValidator: (inputValue) => {
                                return new Promise((resolve) => {
                                    if (inputValue === (a+b).toString()) {
                                        resolve()
                                    } else {
                                        resolve(this.$t('stock_take_detail_fix_confirm_wrong'))
                                    }
                                })
                            },
                            showCancelButton: true,
                            confirmButtonText: this.$t('stock_take_detail_adjust'),
                            showLoaderOnConfirm: true,
                            preConfirm: () => {
                                return new Promise(async (resolve) => {
                                    await this.$mainApi.post('api/inventory/adjustment/', {
                                        "data": this.tabulator.getSelectedData(),
                                        "reason": `Stock Take Adjustment from ID: ${this.stockTakeMain.name} (${this.stockTakeMain.id})`,
                                        "main": this.stockTakeMain.id,
                                    })
                                        .then(response => {
                                            resolve(response.data)
                                        })
                                        .catch(error => {
                                            this.$swal.showValidationMessage(
                                                `Request failed: ${error}`
                                            )
                                        })
                                })
                            },
                            allowOutsideClick: () => !this.$swal.isLoading()
                        }).then((result) => {
                            if (result.isConfirmed) {
                                if(result.value.status === 80){
                                    if(result.value.errors.error_details.length > 0){
                                        let error_details = result.value.errors.error_details
                                        let html = ""
                                        for(let i=0;i<error_details.length;i++){
                                            let this_item = error_details[i]
                                            html += `
<div class='card-body' style="border: black solid 2px;margin: auto;padding: 5px;">
    <p>${this_item['errors']}</p>
    <p>OutCode: ${this_item['data']['outCode']}</p>
    <p>Location: ${this_item['data']['location']} ${this_item['data']['area']}</p>
    <p>Different: ${this_item['data']['different']}</p>
    <hr>
    <div class='row'>
`
                                            for(let key2 in this_item['details']){
                                                html += `
<div class="col-md-4">
    <p>${key2}</p>
</div>
<div class="col-md-8">
    <p>${this_item['details'][key2][0]}</p>
</div>
`
                                            }
                                            html += "</div></div><hr>"
                                        }
                                        this.$swal.fire({
                                            title: this.$t('stock_take_detail_fix_data_have_error'),
                                            html: html,
                                            icon: 'warning'
                                        })
                                    }else{
                                        this.$swal.fire({
                                            title: this.$t('common_success'),
                                            icon: 'success'
                                        })
                                    }
                                    this.getBackendData(this.stockTakeMain.id)
                                }else{
                                    this.$swal.fire({
                                        title: result.value.errors,
                                        text: JSON.stringify(result.value.details),
                                        icon: 'error'
                                    })
                                }
                            }
                        })
                    }
                })
            }
        },
        toggleSelectAll(){
            this.selectAllFlag = !this.selectAllFlag
            if(this.selectAllFlag === true){
                this.tabulator.deselectRow()
                this.button_name = this.$t('common_row_select_all')
            }else{
                this.tabulator.selectRow()
                this.button_name = this.$t('common_row_unselect_all')
            }
        },
        addNewRecord(){
            this.$router.push(`/stock-take/details/add/${this.stockTakeMain.id}`)
        },
        tableFilterBy(){
            if(this.filterBy === "all"){
                this.tabulator.setData(this.mainData)
            }else if(this.filterBy === "less"){
                this.tabulator.setData(this.mainData.filter(a => a.different < 0))
            }else if(this.filterBy === "more"){
                this.tabulator.setData(this.mainData.filter(a => a.different > 0))
            }else if(this.filterBy === "ok"){
                this.tabulator.setData(this.mainData.filter(a => a.different === 0))
            }
            this.tabulator.redraw()
        },
        tableGroupBy(){
            if(this.groupBy === "no"){
                this.tabulator.setGroupBy("")
                this.tabulator.setSort([
                    {column:"location", dir:"asc"},
                ]);
            }else if(this.groupBy === "outCode"){
                this.tabulator.setGroupBy("outCode")
                this.tabulator.setSort("outCode", "asc");
            }else if(this.groupBy === "loc"){
                this.tabulator.setGroupBy("location")
                this.tabulator.setSort([
                    {column:"location", dir:"asc"},
                ]);
            }else if(this.groupBy === "cat"){
                this.tabulator.setGroupBy("category_name")
                this.tabulator.setSort("category_name", "asc");
            }else if(this.groupBy === "brand"){
                this.tabulator.setGroupBy("brand_name")
                this.tabulator.setSort("brand_name", "asc");
            }
            this.tabulator.redraw()
        },
        filterSelected(){
            let nowTableData = this.mainData
            if(this.getCategory.length > 0 && this.getBrand.length > 0){
                nowTableData = nowTableData.filter(a => this.getCategory.includes(a.category_name) || this.getBrand.includes(a.brand_name))
            }
            if(this.getCategory.length > 0 ){
                nowTableData = nowTableData.filter(a => this.getCategory.includes(a.category_name))
            }
            if(this.getBrand.length > 0 ){
                nowTableData = nowTableData.filter(a => this.getBrand.includes(a.brand_name))
            }
            this.tabulator.setData(nowTableData)
            this.tabulator.redraw()
        },
        async getFilterData(){
            await this.$mainApi.get('api/product/filter/')
                .then(response => {
                    if(response.data.status === 80){
                        // 1 -> Category, 2 -> Brand
                        this.categoryList = response.data.details[0]["1"]
                        this.brandList = response.data.details[1]["2"]
                    }
                })
        },
        getHeaderMenu(){
            return this.$getHeaderMenu(this.tabulator)
        },
        async getBackendData(getID){
            await this.$mainApi.get(`api/stock-take/stock-take-detail?id=${getID}`)
                .then(response => {
                    if(response.data.status === 80){
                        this.stockTakeMain = response.data.details.main
                        this.mainData = response.data.details.list
                        this.tabulator.setData(this.mainData)
                    }
                })
        },
        async reloadTable() {
            this.$store.commit('setIsTopLoading', true)
            await this.getBackendData(this.stockTakeMain.id)
            this.filterSelected()
            this.$store.commit('setIsTopLoading', false)
        },
        // async autoReloadTable() {
        //     this.autoLoader = setInterval( async () => {
        //         console.log("Reload Table ...")
        //         let selectedList = this.tabulator.getSelectedData().map(a => a.id);
        //         console.log(selectedList)
        //         await this.getBackendData(this.stockTakeMain.id)
        //         this.filterSelected()
        //         this.tabulator.selectRow(this.tabulator.getRows().filter(row => selectedList.includes(row.getData().id)));
        //         this.tabulator.scrollToRow(this.scrollPosition, "top", true);
        //     }, 5000)
        // }
    },
    mounted(){
        document.title = this.$t('title') + ' | ' + this.$t('stock_take_manage')
        this.button_name = this.$t('common_row_select_all')
        this.getFilterData()
        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {formatter: 'rownum', maxWidth: 20, responsive: 0},
                {
                    title: this.$t('table_outCode'), field: 'outCode', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 200, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_innerCode'), field: 'innerCode', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 200, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_name'), field: this.$store.state.language === 'en' ? 'name_en' : 'name_zh',
                    sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_location'), field: 'location', sorter: 'number', resizable: false,
                    responsive: 0, minWidth: 50, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_area'), field: 'area', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 50, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_category'), field: 'category_name', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 1, hozAlign: "center",  visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_brand'), field: 'brand_name', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 1, hozAlign: "center",  visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_expectedQty'), field: 'expectedQty', sorter: 'number', resizable: false,
                    responsive: 1, widthGrow: 1.5, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_scannedQty'), field: 'scannedQty', sorter: 'number', resizable: false,
                    responsive: 1, widthGrow: 1.5, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_different'), field: 'different', sorter: 'number', resizable: false,
                    responsive: 1, widthGrow: 1.5, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_adjust'), field: 'adjustFlag', sorter: 'string', resizable: false,
                    formatter:"tickCross",
                    responsive: 1, width: 50, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_inner_packing'), field: 'inner packing', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, hozAlign: "center", visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_outer_packing'), field: 'outer packing', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, hozAlign: "center", visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_color'), field: 'color', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 1, hozAlign: "center", visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_material'), field: 'material', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 1, hozAlign: "center", visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_size'), field: 'size', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, hozAlign: "center", visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_p_remarks'), field: 'product_remarks', sorter: 'string', resizable: false,
                    responsive: 1, widthGrow: 2, hozAlign: "center", visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {field: 'id', visible: false},
                {field: 'locID', visible: false},
                {
                    formatter: () => {
                        return "<i class='bi bi-plus-circle-fill'></i>"
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerMenu: this.getHeaderMenu, headerClick: this.closeAllSubTable,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick:
                        async (e, row, formatterParams) => {
                            const id = row.getData().id;

                            let parent = document.getElementById("subParent-" + id + "")

                            if (parent.style.display === "none") {
                                parent.style.display = 'block'

                                let mainContainer = document.createElement("div")
                                parent.appendChild(mainContainer);
                                mainContainer.setAttribute('id', 'mainContainer' + id)
                                mainContainer.style.textAlign = "center"

                                let loading = document.createElement("div")
                                mainContainer.appendChild(loading);
                                loading.setAttribute('class', 'spinner-grow')
                                loading.setAttribute('role', 'status')

                                let tableEl = document.createElement("div");
                                mainContainer.appendChild(tableEl);
                                tableEl.style.border = "1px solid #333";
                                tableEl.style.margin = "auto";
                                tableEl.setAttribute('id', "subTableID-" + id + "");
                                tableEl.setAttribute('class', "subTable");

                                let thisModelData = ""
                                await this.$mainApi.get(`api/stock-take/stock-take-detail-details?id=${id}`)
                                    .then(response => {
                                        if(response.data.status === 80){
                                            thisModelData = response.data.details
                                        }
                                    })
                                loading.remove()

                                this.subTable = new Tabulator(tableEl, {
                                    placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
                                    maxHeight: '20vh',
                                    responsiveLayout: 'collapse',
                                    layout: "fitColumns",
                                    movableColumns: true,
                                    movableRows: false,
                                    data: thisModelData,
                                    columns: [
                                        {
                                            title: 'create Date',
                                            field: 'scanDateTime',
                                            sorter: 'string',
                                            resizable: false,
                                            responsive: 1,
                                            widthGrow: 2,
                                        },
                                        {
                                            title: 'Last Update', field: 'updateTime', sorter: 'string', resizable: false,
                                            responsive: 1, widthGrow: 2,
                                        },
                                        {
                                            title: 'User', field: 'show_name', sorter: 'string', resizable: false,
                                            responsive: 1, widthGrow: 1,
                                        },
                                        {
                                            title: 'Scan Qty', field: 'scanQty', sorter: 'number', resizable: false,
                                            responsive: 1, widthGrow: 1,
                                        },
                                        {
                                            title: this.$t('table_remarks'), field: 'remarks', sorter: 'string', resizable: false,
                                            responsive: 1, widthGrow: 1,
                                        },
                                        {field: 'id', visible: false},
                                        {
                                            formatter:() => {
                                                return "<i class='bi bi-pencil-fill'></i>"
                                            }, resizable: false, responsive: 1, width: 50,
                                            cellClick: (e, row2, formatterParams) => {
                                                if(this.showEditButton){
                                                    this.toggleEditPopUp(1, row2.getData(), row.getData().locID)
                                                }else{
                                                    this.$toast.error(this.$t('error_no_permission'))
                                                }
                                            }
                                        },
                                        {
                                            formatter:() => {
                                                return "<i class='bi bi-trash-fill'></i>"
                                            }, resizable: false, responsive: 1, width: 50,
                                            cellClick: (e, row2) => {
                                                if(this.showDeleteButton){
                                                    this.$swal.fire({
                                                        title: this.$t('common_confirm_action_delete'),
                                                        icon: 'warning',
                                                    }).then(async result => {
                                                        if (result.isConfirmed) {
                                                            await this.$mainApi.delete(`api/stock-take/stock-take-detail-details?id=${row2.getData().id}`)
                                                                .then(response=> {
                                                                    if(response.data.status === 80){
                                                                        this.getBackendData(this.stockTakeMain.id)
                                                                    }
                                                                })
                                                        }
                                                    })
                                                }else{
                                                    this.$toast.error(this.$t('error_no_permission'))
                                                }
                                            }
                                        },
                                    ],
                                })

                                this.tabulatorTablesList.push(
                                    {
                                        "id": id,
                                        "table": this.subTable
                                    }
                                )
                            } else {
                                this.tabulatorTablesList = this.tabulatorTablesList.filter(a => a.id !== parseInt(id))
                                document.getElementById("mainContainer" + id).remove()
                                parent.style.display = 'none'
                            }
                        }
                },
            ],
            reactiveData: true, //enable data reactivity
            height: '90vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
            selectable:true,
            selectableRangeMode:"click",
            initialSort:[
                {column:"location", dir:"asc"},
            ],
            rowFormatter: (row, e) => {
                // Should not be here
                if(row.getData().expectedQty === 0){
                    row.getElement().style.backgroundColor = "#f2b7fc"
                }else{
                    if(row.getData().different > 0){
                        row.getElement().style.backgroundColor = "#dbf8ff"
                    }else if(row.getData().different < 0){
                        row.getElement().style.backgroundColor = "#ffdbdb"
                    }else if(row.getData().different === 0){
                        row.getElement().style.backgroundColor = "#dfffdb"
                    }
                }

                //create and style holder elements
                let holderEl = document.createElement("div");

                const subTable = row.getData().id;

                holderEl.style.display = "none";
                holderEl.style.boxSizing = "border-box";
                holderEl.style.padding = "10px 10px 10px 10px";
                holderEl.style.borderTop = "1px solid #333";
                holderEl.style.borderBotom = "1px solid #333";
                holderEl.style.width = "90vw";
                holderEl.style.background = "#ffffff";

                holderEl.setAttribute('id', "subParent-" + subTable + "");
                holderEl.setAttribute('class', "subParent");

                row.getElement().appendChild(holderEl);
            }
        })

        this.reloadTable()

        this.tabulator.on('rowSelectionChanged', (data, rows) => {
            this.selectedRowsNum = rows.length
        })

        // this.tabulator.on("rowMouseEnter", (e, row) => {
        //     this.scrollPosition = row.getIndex()
        //     // console.log("cell position: " + this.scrollPosition)
        //     console.log(row.getRows(true))
        // });

        // this.tabulator.on("scrollVertical", (top) => {
        //     // this.scrollPosition = top
        //     // console.log(top)
        //     let nowPosition = this.tabulator.getRows("visible")[0]._row.data.id
        //     if(nowPosition === 1){
        //
        //     }else{
        //         this.scrollPosition = nowPosition
        //     }
        //     console.log(this.scrollPosition)
        // });
        // https://stackoverflow.com/questions/68001406/how-to-get-the-row-at-a-specific-point-in-tabulator
        // https://stackoverflow.com/questions/66920201/react-tabulator-looses-scroll-selection-after-replacedata

        // Only One Listener, loop though subTable
        addEventListener('resize', () => {
            let a = document.getElementsByClassName('subTable')
            for (let i = 0; i < a.length; i++) {
                let getID = (a[i].id).split('-')[1]
                try {
                    let this_table = this.tabulatorTablesList.filter(a => a.id === parseInt(getID))[0]['table']
                    this_table.redraw()
                } catch (e) {
                    // pass
                }
            }
        })

        // this.autoReloadTable()


    }
}
</script>

<style scoped>

</style>
